import styled from 'styled-components';

export const MetaStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
